import { render, staticRenderFns } from "./DsMain.vue?vue&type=template&id=6713d568&scoped=true"
import script from "./DsMain.vue?vue&type=script&lang=js"
export * from "./DsMain.vue?vue&type=script&lang=js"
import style0 from "./DsMain.vue?vue&type=style&index=0&id=6713d568&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6713d568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6713d568')) {
      api.createRecord('6713d568', component.options)
    } else {
      api.reload('6713d568', component.options)
    }
    module.hot.accept("./DsMain.vue?vue&type=template&id=6713d568&scoped=true", function () {
      api.rerender('6713d568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DsMain.vue"
export default component.exports